export default "__VITE_ASSET__caf22cca__"